"use client"

import { useSyncExternalStore } from "react"

const NARROW_QUERY = "(max-width: 1279px)"

function subscribe(onStoreChange: () => void) {
  const media = window.matchMedia(NARROW_QUERY)
  media.addEventListener("change", onStoreChange)
  return () => {
    media.removeEventListener("change", onStoreChange)
  }
}

function getSnapshot() {
  return window.matchMedia(NARROW_QUERY).matches
}

function getServerSnapshot() {
  return false
}

export function useNarrowViewport() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
